import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { IMAGES } from "../data/site";
import { Overline, SectionTitle, Accent, Reveal } from "./Reveal";

const CountUp = ({ target, duration = 1800 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let start = null;
    let raf;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min((t - start) / duration, 1);
      setValue(Math.round(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, target, duration]);
  return <span ref={ref}>{value}</span>;
};

const STATS = [
  { prefix: "+R$ ", target: 900, suffix: " mi", label: "de economia gerada para os clientes" },
  { prefix: "+", target: 100, suffix: "", label: "usinas solares em operação" },
  { prefix: "+", target: 30, suffix: " mil", label: "licenciados" },
  { prefix: "+", target: 800, suffix: " mil", label: "clientes conectados" },
];

export const Stats = () => (
  <section className="relative py-24 sm:py-32 overflow-hidden" data-testid="stats-section">
    <div className="absolute inset-0">
      <img src={IMAGES.solarField} alt="" className="w-full h-full object-cover opacity-15" />
      <div className="absolute inset-0 bg-[#04120E]/80" />
    </div>
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Overline>A iGreen em números</Overline>
        <SectionTitle className="max-w-3xl">
          Energia por assinatura em todo o <Accent>Brasil</Accent>
        </SectionTitle>
        <p className="mt-4 max-w-2xl text-sm text-emerald-100/55 leading-relaxed">
          Números divulgados pela iGreen Energy no site oficial (igreenenergy.com.br). O desconto depende da distribuidora da sua região.
        </p>
      </Reveal>
      <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-5">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.1}>
            <div
              data-testid={`stat-card-${i}`}
              className="group rounded-2xl border border-[#00E676]/20 bg-[#0B261E]/70 backdrop-blur-md p-6 sm:p-8 transition-[border-color,transform] duration-300 hover:border-[#00E676]/50 hover:-translate-y-1"
            >
              <p className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white">
                <span className="text-[#00E676] text-xl sm:text-2xl align-top">{s.prefix}</span>
                <CountUp target={s.target} />
                <span className="text-[#00E676] text-xl sm:text-2xl">{s.suffix}</span>
              </p>
              <p className="mt-3 text-xs sm:text-sm text-emerald-100/55 leading-snug">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
